import { Outlet } from 'react-router-dom';

/**
 * Minimal layout without header/footer
 * Used for full-screen flows like Purchase
 */
export function MinimalLayout() {
  return (
    <Outlet />
  );
}
